/**
 * This file is auto-generated from ChatProfileDataSent.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const title: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Your personal data';
        case 'pl':
            return 'Twoje dane osobowe';
    }
};
